import TeamStandingsTabContent from './TeamStandingsTabContent';

export default TeamStandingsTabContent;